/* CSS */
import "@js/parts/css";

/* JS */
import "@js/parts/lazyloading";
import Swiper from 'swiper/bundle';
import { Fancybox } from "@fancyapps/ui/dist/fancybox/";

/**
 * Alpine JS
 * Best to put it last so that all other potential JS is available
 * when components start getting initialized.
 */
import Alpine from 'alpinejs';
window.Alpine = Alpine;
window.Swiper = Swiper;

Alpine.start();
Fancybox.bind("[data-fancybox]", {
  Carousel: {
    Toolbar: {
      display: {
        right: ["close"],
      },
    },
  },
});
/**
 * Accept HMR as per: https://vitejs.dev/guide/api-hmr.html
 */
if (import.meta.hot) {
  import.meta.hot.accept(() => {
    console.log("HMR");
  });
}
